import { GeoJsonObject } from 'geojson'
import L from 'leaflet'
import { useMemo, useState } from 'react'
import { GeoJSON } from 'react-leaflet'

import Loading from '@/components/loading'
import { Map as MapContainer } from '@/components/map'
import CustomControl from '@/components/map/custom-control'

import { GeoTiff } from '../geo-tiff'
import { useStyles } from './styles'

interface MapProps {
  perimeter: GeoJsonObject
  mosaic?: File
}

function Map({ perimeter, mosaic }: MapProps) {
  const classes = useStyles()
  const [isGeoTiffReady, setIsGeoTiffReady] = useState(false)
  const [isGeoTiffError, setIsGeoTiffError] = useState(false)

  const bounds = useMemo(() => L.geoJSON(perimeter).getBounds(), [perimeter])

  return (
    <div className={classes.mapContainer}>
      <MapContainer
        zoomSnap={0.25}
        bounds={bounds}
        maxBounds={bounds}
        whenCreated={(map) => map.invalidateSize()}
        disabledControls
        opacity={isGeoTiffReady ? 0.5 : 1}
      >
        <GeoTiff
          file={mosaic}
          onReady={() => setIsGeoTiffReady(true)}
          onError={() => setIsGeoTiffError(true)}
        />
        <GeoJSON
          data={perimeter}
          style={{
            color: 'white',
            weight: 1.5,
            fillColor: 'white',
            fillOpacity: 0.5,
            interactive: false,
            fillRule: 'nonzero',
          }}
        />
        {mosaic && !isGeoTiffError && !isGeoTiffReady && (
          <CustomControl className='leaflet-control'>
            <Loading color='secondary' size={'2rem'} />
          </CustomControl>
        )}
      </MapContainer>
    </div>
  )
}

export default Map
